import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Button, IconButton, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { TablePagination } from "@mui/material";
import { Paper } from "@mui/material";
import { Box } from "@mui/material";
import { TableCell, TableRow } from "@mui/material";
import { TableBody, TableFooter, TableHead } from "@mui/material";
import { TableContainer } from "@mui/material";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { del, get, post, post_file_faturas } from "../../../Services/tokenConfig";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { IPage9 } from "../../../Interfaces/cadernos/caderno9";
import BasicPopover from "../../../Components/Popover";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { func_print } from "../../../Func_genericas/func_print";
import { Alert } from "../../../Components/Alert/Alert";
import { unidade_medida_Kg_l_t, unidade_medida_Kw } from "../../../informacao_estatica";
import { formatar_numeros_tabela_9 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/cadernos9";
import { desformatarNumero, desformatarNumero_return_null, formatarNumero_ao_digitar } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { ModalValidarDadosFatura } from "./modal_validar_dados_fatura";
import { FilterByData } from "../../../Func_genericas/filter_by_data";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
        },

        toolbars: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(2, 3),
            // necessary for content to be below app bar
            ...theme.mixins.toolbar,
        },
        contents: {
            flexGrow: 1,
            padding: theme.spacing(3),
        },
    })
);


export default function RegAquisicoesEntra() {
    const classes = useStyles();
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;

    const auth = useContext(AuthContext);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = React.useState("");
    const [showNewRow, setShowNewRow] = useState(false);
    const [openDelete, setOpenDelete] = React.useState(false);
    const [obj_aquisicoesBackup, setobj_aquisicoesBackup] = useState<IPage9 | null>(null);
    const [is_tabela_sem_dados, set_is_tabela_sem_dados] = useState(false);

    const [error_data, set_error_data] = useState<boolean>(false);
    const [error_produto, set_error_produto] = useState<boolean>(false);
    const [error_quantidade, set_error_quantidade] = useState<boolean>(false);
    const [error_fornecedor, set_error_fornecedor] = useState<boolean>(false);
    const [error_origem, set_error_origem] = useState<boolean>(false);
    const [error_destino, set_error_destino] = useState<boolean>(false);
    const [error_consumo_energetico, set_error_consumo_energetico] = useState<boolean>(false);
    const [error_doc, set_error_doc] = useState<boolean>(false);
    const [error_unidade_medida_quantidade, set_error_unidade_medida_quantidade] = useState<boolean>(false);
    const [error_unidade_consumo_energetico, set_error_unidade_consumo_energetico] = useState<boolean>(false);
    const message_apenas_numero = ("Apenas números são aceites");
    const message_verifique_campos = ("Verifique e preencha todos os campos corretamente");
    const message_unidade_medida = ("Selecione uma unidade de medida");

    const camposNumericos = ["quantidade", "consumo_energetico", "doc"];

    const [rows, setRows] = useState<IPage9[]>([]);
    const [rows_filtrada, setRows_filtrada] = useState<IPage9[]>([]);

    const [obj_aquisicoes, set_obj_aquisicoes] = useState<IPage9>();
    const [list_aux_from_faturas_obj_aquisicoes, set_list_aux_from_faturas_obj_aquisicoes] = useState<IPage9[]>([]);

    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);
    const [open_modal_confirmar_dados_da_fatura, set_open_modal_confirmar_dados_da_fatura] = React.useState(false);

    const handleCloseDialog = () => {
        handleCancel()


        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    async function getTabela() {
        try {
            let res = await get(auth.token.cookie_token, `/get_reg_adquisicao_entrada_nove_rosto/${location.state.id_rosto}`);

            if (res.status === 200) {
                const result = res.data.result;

                if (result.length > 0) {
                    if (result[0].id_entradas) {
                        const formattedData = result.map(formatar_numeros_tabela_9);
                        setRows(formattedData);
                        setRows_filtrada(formattedData);
                        set_is_tabela_sem_dados(false);
                    }
                } else {
                    set_is_tabela_sem_dados(true)
                }
            }

            setIsLoading(false);
        } catch (error) {
            func_print("getTabela", error, true);
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        (async () => {
            await getTabela();
        })();
    }, []);

    // Criar
    const onInputChage = (event: any) => {
        const { name, value } = event.target;
        const isCampoNumerico = camposNumericos.includes(name);
        set_flag_editado(true)

        if (name === "data") {
            if (value.trim() === "" || value === undefined) {
                set_error_data(true);
            } else {
                set_error_data(false);
            }
        } else if (name === "produto") {
            if (value.trim() === "" || value === undefined) {
                set_error_produto(true);
            } else {
                set_error_produto(false);
            }
        } else if (name === "quantidade") {
            if (value.trim() === "" || value === undefined) {
                set_error_quantidade(true);
            } else {
                set_error_quantidade(false);
            }
        } else if (name === "fornecedor") {
            if (value.trim() === "" || value === undefined) {
                set_error_fornecedor(true);
            } else {
                set_error_fornecedor(false);
            }
        } else if (name === "origem") {
            if (value.trim() === "" || value === undefined) {
                set_error_origem(true);
            } else {
                set_error_origem(false);
            }
        } else if (name === "destino") {
            if (value.trim() === "" || value === undefined) {
                set_error_destino(true);
            } else {
                set_error_destino(false);
            }
        } else if (name === "doc") {
            if (value.trim() === "" || value === undefined) {
                set_error_doc(true);
            } else {
                set_error_doc(false);
            }
        } else if (name === "consumo_energetico") {
            if (value.trim() === "" || value === undefined) {
                set_error_consumo_energetico(true);
            } else {
                set_error_consumo_energetico(false);
            }
        } else if (name === "medida") {
            if (value.trim() === "" || value === undefined) {
                set_error_unidade_medida_quantidade(true);
            } else {
                set_error_unidade_medida_quantidade(false);
            }
        } else if (name === "medida_energetico") {
            if (value.trim() === "" || value === undefined) {
                set_error_unidade_consumo_energetico(true);
            } else {
                set_error_unidade_consumo_energetico(false);
            }
        }

        if (isCampoNumerico) {
            const valorSemFormatar = value.replace(/[^\d,]/g, "");
            set_obj_aquisicoes((prev: any) => ({
                ...prev,
                [name]: formatarNumero_ao_digitar(valorSemFormatar),
            }));
        } else {
            set_obj_aquisicoes((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const handleSave = async () => {
        if (
            obj_aquisicoes?.data === undefined || obj_aquisicoes.data === "" ||
            obj_aquisicoes?.produto === undefined || obj_aquisicoes.produto === "" ||
            obj_aquisicoes?.quantidade === undefined ||
            obj_aquisicoes?.fornecedor === undefined || obj_aquisicoes.fornecedor === "" ||
            obj_aquisicoes?.origem === undefined || obj_aquisicoes.origem === "" ||
            obj_aquisicoes?.destino === undefined || obj_aquisicoes.destino === "" ||
            obj_aquisicoes?.doc === undefined || obj_aquisicoes.doc === "" ||
            obj_aquisicoes?.consumo_energetico === undefined
        ) {

            if (obj_aquisicoes?.data === undefined || obj_aquisicoes.data === "") {
                set_error_data(true);
            }
            if (obj_aquisicoes?.produto === undefined || obj_aquisicoes.produto === "") {
                set_error_produto(true);
            }
            if (obj_aquisicoes?.quantidade === undefined) {
                set_error_quantidade(true);
            }
            if (obj_aquisicoes?.fornecedor === undefined || obj_aquisicoes.fornecedor === "") {
                set_error_fornecedor(true);
            }
            if (obj_aquisicoes?.origem === undefined || obj_aquisicoes.origem === "") {
                set_error_origem(true);
            }
            if (obj_aquisicoes?.destino === undefined || obj_aquisicoes.destino === "") {
                set_error_destino(true);
            }
            if (obj_aquisicoes?.doc === undefined || obj_aquisicoes.doc === "") {
                set_error_doc(true);
            }
            if (obj_aquisicoes?.consumo_energetico === undefined) {
                set_error_consumo_energetico(true);
            }

            setMessage(message_verifique_campos);
            setOpenSnackError(true);
        } else if (obj_aquisicoes?.medida === undefined /* obj_aquisicoes?.medida_energetico === undefined */) {
            set_error_quantidade(false);
            set_error_unidade_consumo_energetico(false);
            set_error_unidade_medida_quantidade(true);
            setMessage(message_verifique_campos);
            setOpenSnackError(true);
        } else if (obj_aquisicoes?.medida_energetico === undefined) {
            set_error_quantidade(false);
            set_error_unidade_medida_quantidade(false);
            set_error_unidade_consumo_energetico(true);
            setMessage(message_verifique_campos);
            setOpenSnackError(true);
        } else {
            try {
                setIsLoading(true);

                let res = await post(auth.token.cookie_token, "/new_reg_adquisicao_entrada_nove", {
                    payload: {
                        id_entradas: 0,
                        data: obj_aquisicoes?.data === undefined ? "" : obj_aquisicoes.data,
                        produto: obj_aquisicoes?.produto === undefined ? "" : obj_aquisicoes.produto,
                        quantidade: obj_aquisicoes?.quantidade === undefined ? null : desformatarNumero(obj_aquisicoes.quantidade),
                        fornecedor: obj_aquisicoes?.fornecedor === undefined ? "" : obj_aquisicoes.fornecedor,
                        origem: obj_aquisicoes?.origem === undefined ? "" : obj_aquisicoes.origem,
                        destino: obj_aquisicoes?.destino === undefined ? "" : obj_aquisicoes.destino,
                        doc: obj_aquisicoes?.doc === undefined ? "" : obj_aquisicoes.doc,
                        consumo_energetico: obj_aquisicoes?.consumo_energetico === undefined ? null : desformatarNumero(obj_aquisicoes.consumo_energetico),
                        obs: obj_aquisicoes?.obs === undefined ? "" : obj_aquisicoes.obs,
                        medida: obj_aquisicoes?.medida === undefined ? "" : obj_aquisicoes.medida,
                        medida_energetico: obj_aquisicoes.medida_energetico === undefined ? "" : obj_aquisicoes.medida_energetico,
                        id_rosto: location.state.id_rosto,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: "",
                    }
                });

                if (res.status === 200) {
                    setMessage("Gravado com sucesso!");
                    setOpenSnackSuccess(true);
                    setShowNewRow(false);

                    setRows((prevRows) => [
                        ...prevRows,
                        formatar_numeros_tabela_9(res.data.result),
                    ])
                    setRows_filtrada((prevRows) => [
                        ...prevRows,
                        formatar_numeros_tabela_9(res.data.result),
                    ])
                    set_flag_editado(false)

                    set_obj_aquisicoes(undefined)
                    set_error_data(false);
                    set_error_produto(false);
                    set_error_quantidade(false);
                    set_error_fornecedor(false);
                    set_error_origem(false);
                    set_error_destino(false);
                    set_error_doc(false);
                    set_error_consumo_energetico(false);
                    set_is_tabela_sem_dados(false)
                } else {
                    setMessage("Erro ao gravar!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);
            } catch (error: any) {
                func_print("handleSaveNewCabecalho", error, true);
                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }
    };

    // EDITAR
    const handleEdit = (obj: IPage9) => {
        set_obj_aquisicoes(obj);
    };

    const handleCancel = () => {
        setShowNewRow(false);
        set_obj_aquisicoes(undefined);
        set_error_data(false);
        set_error_produto(false);
        set_error_quantidade(false);
        set_error_fornecedor(false);
        set_error_origem(false);
        set_error_destino(false);
        set_error_doc(false);
        set_error_consumo_energetico(false);
    }



    const handleUpdate = async () => {

        if (
            obj_aquisicoes?.data === undefined || obj_aquisicoes?.data === "" ||
            obj_aquisicoes?.produto === undefined || obj_aquisicoes?.produto === "" ||
            obj_aquisicoes?.quantidade === undefined ||
            obj_aquisicoes?.fornecedor === undefined || obj_aquisicoes?.fornecedor === "" ||
            obj_aquisicoes?.origem === undefined || obj_aquisicoes?.origem === "" ||
            obj_aquisicoes?.destino === undefined || obj_aquisicoes?.destino === "" ||
            obj_aquisicoes?.doc === undefined || obj_aquisicoes?.doc === "" ||
            obj_aquisicoes?.consumo_energetico === undefined ||
            obj_aquisicoes?.medida === undefined ||
            obj_aquisicoes?.medida_energetico === undefined
        ) {
            if (obj_aquisicoes?.data === undefined || obj_aquisicoes.data === "") {
                set_error_data(true);
            }
            if (obj_aquisicoes?.produto === undefined || obj_aquisicoes.produto === "") {
                set_error_produto(true);
            }
            if (obj_aquisicoes?.quantidade === undefined) {
                set_error_quantidade(true);
            }
            if (obj_aquisicoes?.fornecedor === undefined || obj_aquisicoes.fornecedor === "") {
                set_error_fornecedor(true);
            }
            if (obj_aquisicoes?.origem === undefined || obj_aquisicoes.origem === "") {
                set_error_origem(true);
            }
            if (obj_aquisicoes?.destino === undefined || obj_aquisicoes.destino === "") {
                set_error_destino(true);
            }
            if (obj_aquisicoes?.doc === undefined || obj_aquisicoes.doc === "") {
                set_error_doc(true);
            }
            if (obj_aquisicoes?.consumo_energetico === undefined) {
                set_error_consumo_energetico(true);
            }

            setMessage(message_verifique_campos);
            setOpenSnackError(true);
        } else {
            try {
                setIsLoading(true);
                const res = await post(auth.token.cookie_token, "/update_reg_adquisicao_entrada_nove", {
                    payload: {
                        id_entradas: obj_aquisicoes.id_entradas,
                        data: obj_aquisicoes?.data === undefined ? "" : obj_aquisicoes.data,
                        produto: obj_aquisicoes?.produto === undefined ? "" : obj_aquisicoes.produto,
                        quantidade: obj_aquisicoes?.quantidade === undefined ? null : desformatarNumero_return_null(obj_aquisicoes.quantidade),
                        fornecedor: obj_aquisicoes?.fornecedor === undefined ? "" : obj_aquisicoes.fornecedor,
                        origem: obj_aquisicoes?.origem === undefined ? "" : obj_aquisicoes.origem,
                        destino: obj_aquisicoes?.destino === undefined ? "" : obj_aquisicoes.destino,
                        doc: obj_aquisicoes?.doc === undefined ? "" : obj_aquisicoes.doc,
                        consumo_energetico: obj_aquisicoes?.consumo_energetico === undefined ? null : desformatarNumero_return_null(obj_aquisicoes.consumo_energetico),
                        obs: obj_aquisicoes?.obs === undefined ? "" : obj_aquisicoes.obs,
                        medida: obj_aquisicoes?.medida === undefined ? "" : obj_aquisicoes.medida,
                        medida_energetico: obj_aquisicoes?.medida_energetico === undefined ? "" : obj_aquisicoes.medida_energetico,
                        id_rosto: obj_aquisicoes?.id_rosto,
                        last_update: obj_aquisicoes?.last_update,
                        create_date: obj_aquisicoes?.create_date,
                        uuid: obj_aquisicoes?.uuid,
                    }
                });
                if (res.status === 200) {
                    setMessage("Registado com sucesso!");

                    const updatedRows = rows.map((row) => {
                        if (row.id_entradas === res.data.result.id_entradas) {
                            return formatar_numeros_tabela_9(res.data.result);
                        } else {
                            return row
                        }
                    });

                    setRows(updatedRows !== undefined ? updatedRows : []);
                    setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
                    set_obj_aquisicoes(undefined)
                    setOpenSnackSuccess(true);
                    set_error_data(false);
                    set_error_produto(false);
                    set_error_quantidade(false);
                    set_error_fornecedor(false);
                    set_error_origem(false);
                    set_error_destino(false);
                    set_error_doc(false);
                    set_flag_editado(false)
                    set_error_consumo_energetico(false);
                } else {
                    setMessage("Erro ao gravar!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print("handleUpdate", error, true);
                setMessage("Erro ao gravar!");
                setOpenSnackError(true);
                setIsLoading(false);
            }
        }

    };

    // DELETE
    const handleClickOpenDelete = (obj: IPage9) => {
        set_obj_aquisicoes(obj);
        setOpenDelete(true);
    };

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            let res = await del(auth.token.cookie_token, `/delete_adquisicao_entrada_nove/${obj_aquisicoes?.id_entradas}`);

            if (res.status === 200) {
                setMessage("Registo eliminado com sucesso!");
                setOpenDelete(false);

                setRows((oldRows) => [
                    ...oldRows.filter((oldRow) => oldRow.id_entradas !== obj_aquisicoes?.id_entradas),
                ]);
                setRows_filtrada((oldRows) => [
                    ...oldRows.filter((oldRow) => oldRow.id_entradas !== obj_aquisicoes?.id_entradas),
                ]);
                set_obj_aquisicoes(undefined)
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handleDelete", error, true);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    /*****************  PAGINAÇÃO ********************** */
    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const uploadDocumento = async (selectedFile: File) => {
        if (!selectedFile) {
            setMessage("Nenhum ficheiro selecionado.");
            setOpenSnackError(true);
            return;
        }
        try {
            setIsLoading(true);
            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await post_file_faturas(auth.token.cookie_token, `/analisar`, formData);

            if (response.status === 200) {

                setMessage("Documento carregado com sucesso!");
                setOpenSnackSuccess(true);
                console.log('response', response.data.fatura);
                if (Array.isArray(response.data.fatura.artigos) && response.data.fatura.artigos.length > 0) {
                    let aux_data = response.data.fatura.data ? new Date(response.data.fatura.data).toISOString().split('T')[0] : "";
                    let aux_fornecedor = response.data.fatura.fornecedor ? response.data.fatura.fornecedor : "";
                    let aux_destino = response.data.fatura.cliente ? response.data.fatura.cliente : "";
                    let aux_doc = response.data.fatura.numero_documento ? response.data.fatura.numero_documento : "";

                    let aux_list_from_faturas = response.data.fatura.artigos.map((el: any) => {
                        return {
                            id_entradas: 0,
                            data: aux_data,
                            produto: el.descricao,
                            quantidade: el.quantidade,
                            fornecedor: aux_fornecedor,
                            origem: '',
                            destino: aux_destino,
                            doc: aux_doc,
                            consumo_energetico: 0,
                            obs: "",
                            medida: el.unidade_medida_quantidade,
                            medida_energetico: el.unidade_medida_consumo_energetico,
                            id_rosto: location.state.id_rosto,
                            last_update: new Date().toISOString(),
                            create_date: new Date().toISOString(),
                            uuid: "",
                        }

                    })

                    set_list_aux_from_faturas_obj_aquisicoes(aux_list_from_faturas);

                    set_open_modal_confirmar_dados_da_fatura(true)
                }
                else {
                    setMessage("Documento carregado, mas nenhum artigo foi encontrado.");

                    setOpenSnackError(true);
                }
                // setSelectedFile(selectedFile)
                // setFileName(response.data.result.file)
                // setSelectedFile(new File([], response.data.result.file, { type: 'application/pdf' }));


            } else {
                setMessage("Erro ao carregar documento.");
                setOpenSnackError(true);
            }
        } catch (error: any) {
            func_print("uploadDocumento", error, true);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage("Erro ao efetuar a sua operação!");
            }
            setIsLoading(false);
            setOpenSnackError(true);
        } finally {
            setIsLoading(false);
        }

    }

    return (
        <div className={classes.root}>
            <CadernoLayout title="9 - Registo de Aquisições /Entradas" />
            <main className={classes.contents}>
                <div className={classes.toolbars} />
                <Box width="80%" margin="auto">
                    <BeneficiarioNomeIdAlinhadoDireita />
                </Box>
                <FilterByData
                    listas={[
                        {
                            lista_original: rows,
                            set_lista_filtrada: setRows_filtrada,
                            campoData: "data",
                        },

                    ]}
                />
                {isLoading ? (
                    <LoadingVulpes />
                ) : (
                    <CustomThemeProvider>
                        <TableContainer
                            component={Paper}
                            variant="outlined"
                            sx={{
                                height: "auto",
                                width: "auto",
                                margin: 2,
                                padding: 2,
                            }}
                        >
                            <Snackbar
                                open={openSnackSuccess}
                                autoHideDuration={2000}
                                onClose={() => setOpenSnackSuccess(false)}
                            >
                                <Alert
                                    onClose={() => setOpenSnackSuccess(false)}
                                    severity="success"
                                    sx={{ width: "100%" }}
                                >
                                    {message}
                                </Alert>
                            </Snackbar>
                            <Snackbar
                                open={openSnackError}
                                autoHideDuration={2000}
                                onClose={() => setOpenSnackError(false)}
                            >
                                <Alert
                                    onClose={() => setOpenSnackError(false)}
                                    severity="error"
                                    sx={{ width: "100%" }}
                                >
                                    {message}
                                </Alert>
                            </Snackbar>

                            <table style={{ width: "100%" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            colSpan={8}
                                            sx={{ fontWeight: 700, fontSize: 18, fontFamily: "candara", }} >
                                            <Stack direction="row" justifyContent="left" alignItems="center">
                                                9 - Registo de Aquisições/Entradas
                                                <BasicPopover text={"Quadro de preenchimento obrigatório caso o beneficiário tenha compromisso ativo na intervenção Agricultura Biológica ou PRODI (todos os campos devem ser preenchidos se aplicáveis, exceto o campo 'fornecedor').\n\nO Registo de aquisições/entradas, no caso de o beneficiário assim o desejar, pode ser utilizado para cumprimento do indicador 2.1 da área 2 (no que respeita às aquisições) do RLG 5 da Portaria n.º 54-Q/2023, de 27 de fevereiro e de acordo com as diretrizes constantes na Orietação Técnica Geral - Condicionalidade - Requisitos Legais de Gestão, GPP/OT/2023/4, devendo ser preenchidos os seguintes campos do quadro do Separador 9:\n -Data;     \n- Produto;     \n- Quantidade;     \n- Fornecedor."} />
                                            </Stack>
                                        </TableCell>
                                        <TableCell colSpan={2}>
                                            <Stack direction="row" sx={{ justifyContent: "end" }}>
                                                {is_historico === true ? <></> :

                                                    <BarraDeFerramentas
                                                        mostrarBotaoNovo
                                                        textoBotaoNovo="Novo Registo"
                                                        aoClicarNovo={() => {
                                                            set_error_unidade_consumo_energetico(false);
                                                            set_error_unidade_medida_quantidade(false);
                                                            set_error_quantidade(false);
                                                            set_error_consumo_energetico(false);
                                                            setShowNewRow(true)
                                                            set_obj_aquisicoes(undefined)
                                                        }}
                                                    />}
                                                <Button
                                                    component="label"
                                                    role={undefined}
                                                    // variant="contained"
                                                    tabIndex={-1}
                                                    // startIcon={<FileUploadIcon />}
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: cores.cor1,
                                                        // maxHeight: 30,
                                                        // width: 250,
                                                        // marginRight: 10
                                                        cursor: "pointer",
                                                        // padding: "8px 12px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "6px",
                                                        // display: "inline-block",
                                                        // importante
                                                        whiteSpace: "nowrap",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        minWidth: "fit-content",
                                                        marginLeft: 5
                                                    }}
                                                >
                                                    <FileUploadIcon />

                                                    Upload de Fatura

                                                    <input
                                                        type="file"
                                                        accept="application/pdf,image/*"
                                                        // label="Upload de Fatura"
                                                        hidden
                                                        multiple={false}
                                                        onChange={(event) => {
                                                            const file = event.target.files?.[0];
                                                            if (file) {
                                                                uploadDocumento(file);
                                                            }
                                                        }}
                                                    />
                                                </Button>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableHead>Data*</StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 150 }}>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Produto (fator de produção)*
                                                <BasicPopover text={"Produto (fator de produção) – Registar todos os inputs aplicados em cada zona homogénea."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 150 }}>
                                            <Stack direction="row" justifyContent="center">
                                                Quantidade (Kg, L, Ton.)*
                                                <BasicPopover text={"Quantidade (kg, L, t) – Descriminar individualmente a quantidade aplicada."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Fornecedor*
                                                <BasicPopover text={"Preencher campo apenas quando o Separador 9 é utilizado para o cumprimento do registo das aquisições no âmbito do indicador 1.1 da área 1 e do indicador 2.1 da área 2 do RLG 5 da Portaria n.º 54-Q/2023."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 150 }}>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Origem*
                                                <BasicPopover text={" Identificar a origem quando o produto é proveniente do\n exterior da unidade: fornecedor, exploração, região, país. \nRegisto facultativo quando a origem esteja explícita em\n documento anexo."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 150 }}>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Destino*
                                                <BasicPopover text={" Local ou animais da unidade a que se destina: \n parcela, zona/lote homogéneo, transformação, armazém, etc."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 130 }}>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Docum. Nº*
                                                <BasicPopover text={" Para facilitar a identificação, pode-se\n assinalar os documentos de compra com\n números sequenciais para os\n identificar nesta coluna."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 180 }}>
                                            <Stack direction="row" justifyContent="center" alignItems="center">
                                                Consumo enérgico eléctrico (kWh/t ou kWh/ha)*
                                                <BasicPopover text={" Sempre que exista contador de energia elétrica. \nA periodicidade pode ser ajustada às necessidades individuais."} />
                                            </Stack>
                                        </StyledTableHead>
                                        <StyledTableHead sx={{ minWidth: 180 }}>Observações</StyledTableHead>
                                        <StyledTableHead>Ações</StyledTableHead>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {showNewRow && (
                                        <>
                                            <TableRow>
                                                <StyledTableCell>
                                                    <TextField
                                                        variant="filled"
                                                        type="date"
                                                        inputProps={{ style: { fontSize: 12, fontFamily: "verdana", }, }}
                                                        name="data"
                                                        InputLabelProps={{ shrink: true, }}
                                                        value={obj_aquisicoes?.data === undefined ? "" : obj_aquisicoes.data}
                                                        onChange={onInputChage}
                                                        error={error_data}
                                                        helperText={error_data ? "Preencha este campo" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="produto"
                                                        value={obj_aquisicoes?.produto === undefined ? "" : obj_aquisicoes.produto}
                                                        onChange={onInputChage}
                                                        error={error_produto}
                                                        helperText={error_produto ? "Preencha este campo" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Stack direction="row" alignItems="center">
                                                        <CustomTextField
                                                            name="quantidade"
                                                            value={obj_aquisicoes?.quantidade === undefined ? "" : obj_aquisicoes.quantidade}
                                                            onChange={onInputChage}
                                                            error={error_quantidade || error_unidade_medida_quantidade}
                                                            helperText={
                                                                error_quantidade ? message_apenas_numero :
                                                                    error_unidade_medida_quantidade ? message_unidade_medida : ""
                                                            }
                                                        />
                                                        <CustomSelect
                                                            value={obj_aquisicoes?.medida !== undefined ? obj_aquisicoes.medida : ""}
                                                            name="medida"
                                                            onChange={onInputChage}
                                                            options={unidade_medida_Kg_l_t}
                                                            label="UM"
                                                            minWidth={50}

                                                        />
                                                    </Stack>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="fornecedor"
                                                        value={obj_aquisicoes?.fornecedor === undefined ? "" : obj_aquisicoes.fornecedor}
                                                        onChange={onInputChage}
                                                        error={error_fornecedor}
                                                        helperText={error_fornecedor ? "Preencha este campo" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="origem"
                                                        value={obj_aquisicoes?.origem === undefined ? "" : obj_aquisicoes.origem}
                                                        onChange={onInputChage}
                                                        error={error_origem}
                                                        helperText={error_origem ? "Preencha este campo" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="destino"
                                                        value={obj_aquisicoes?.destino === undefined ? "" : obj_aquisicoes.destino}
                                                        onChange={onInputChage}
                                                        error={error_destino}
                                                        helperText={error_destino ? "Preencha este campo" : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="doc"
                                                        // value={documento_sequencial + 1}
                                                        value={obj_aquisicoes?.doc === undefined ? "" : obj_aquisicoes.doc}
                                                        onChange={onInputChage}
                                                        error={error_doc}
                                                        helperText={error_doc ? message_apenas_numero : ""}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Stack direction="row" alignItems="center">
                                                        <CustomTextField
                                                            name="consumo_energetico"
                                                            value={obj_aquisicoes?.consumo_energetico === undefined ? "" : obj_aquisicoes.consumo_energetico}
                                                            onChange={onInputChage}
                                                            /* error={error_quantidade || error_unidade_medida_quantidade}
                                                            helperText={
                                                                error_quantidade ? message_apenas_numero : 
                                                                error_unidade_medida_quantidade ? message_unidade_medida : ""
                                                            } */
                                                            error={error_consumo_energetico || error_unidade_consumo_energetico}
                                                            helperText={
                                                                error_consumo_energetico ? message_apenas_numero :
                                                                    error_unidade_consumo_energetico ? message_unidade_medida : ""
                                                            }
                                                        />
                                                        <CustomSelect
                                                            value={obj_aquisicoes?.medida_energetico !== undefined ? obj_aquisicoes.medida_energetico : ""}
                                                            name="medida_energetico"
                                                            onChange={onInputChage}
                                                            options={unidade_medida_Kw}
                                                            label="UM"
                                                            minWidth={50}
                                                        />
                                                    </Stack>
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <CustomTextField
                                                        name="obs"
                                                        value={obj_aquisicoes?.obs === undefined ? "" : obj_aquisicoes.obs}
                                                        onChange={onInputChage}
                                                    />
                                                </StyledTableCell>
                                                <StyledTableCell>
                                                    <Stack direction="row" justifyContent="center">
                                                        <ButtonCadernos
                                                            mostrarBotaoCancelar
                                                            aoClicarCancelar={() => {
                                                                if (flag_editado) {
                                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                                } else {
                                                                    handleCancel()
                                                                }
                                                            }}
                                                            mostrarBotaoGravar
                                                            aoClicarGravar={() => handleSave()}
                                                        />


                                                    </Stack>
                                                </StyledTableCell>
                                            </TableRow>
                                        </>
                                    )}
                                    {(rowsPerPage > 0
                                        ? rows_filtrada.slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        : rows_filtrada
                                    ).map((row, key) => (
                                        <TableRow key={key}>
                                            {obj_aquisicoes?.id_entradas === row.id_entradas ? (
                                                <>
                                                    <StyledTableCell>
                                                        <TextField
                                                            variant="filled"
                                                            type="date"
                                                            name="data"
                                                            value={obj_aquisicoes?.data}
                                                            onChange={onInputChage}
                                                            error={error_data}
                                                            helperText={error_data ? "Preencha este campo" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="produto"
                                                            value={obj_aquisicoes?.produto}
                                                            onChange={onInputChage}
                                                            error={error_produto}
                                                            helperText={error_produto ? "Preencha este campo" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <Stack direction="row" alignItems="center">
                                                            <CustomTextField
                                                                name="quantidade"
                                                                value={obj_aquisicoes?.quantidade}
                                                                onChange={onInputChage}
                                                                error={error_quantidade || error_unidade_medida_quantidade}
                                                                helperText={
                                                                    error_quantidade ? message_apenas_numero :
                                                                        error_unidade_medida_quantidade ? message_unidade_medida : ""
                                                                }
                                                            />
                                                            <CustomSelect
                                                                value={obj_aquisicoes?.medida !== undefined ? obj_aquisicoes?.medida : ""}
                                                                name="medida"
                                                                onChange={onInputChage}
                                                                options={unidade_medida_Kg_l_t}
                                                                label="UM"
                                                                minWidth={50}
                                                            />
                                                        </Stack>
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="fornecedor"
                                                            value={obj_aquisicoes?.fornecedor}
                                                            onChange={onInputChage}
                                                            error={error_fornecedor}
                                                            helperText={error_fornecedor ? "Preencha este campo" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="origem"
                                                            value={obj_aquisicoes?.origem}
                                                            onChange={onInputChage}
                                                            error={error_origem}
                                                            helperText={error_origem ? "Preencha este campo" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="destino"
                                                            value={obj_aquisicoes?.destino}
                                                            onChange={onInputChage}
                                                            error={error_destino}
                                                            helperText={error_destino ? "Preencha este campo" : ""}
                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="doc"
                                                            value={obj_aquisicoes?.doc}
                                                            onChange={onInputChage}
                                                        // error={error_doc}
                                                        // helperText={error_doc ? message_apenas_numero : ""}

                                                        />
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <Stack direction="row" alignItems="center">
                                                            <CustomTextField
                                                                name="consumo_energetico"
                                                                value={obj_aquisicoes?.consumo_energetico}
                                                                onChange={onInputChage}
                                                                error={error_consumo_energetico || error_unidade_consumo_energetico}
                                                                helperText={
                                                                    error_consumo_energetico ? message_apenas_numero :
                                                                        error_unidade_consumo_energetico ? message_unidade_medida : ""
                                                                }
                                                            />
                                                            <CustomSelect
                                                                value={obj_aquisicoes?.medida_energetico !== undefined ? obj_aquisicoes?.medida_energetico : ""}
                                                                name="medida_energetico"
                                                                onChange={onInputChage}
                                                                options={unidade_medida_Kw}
                                                                label="UM"
                                                                minWidth={50}
                                                            />
                                                        </Stack>
                                                    </StyledTableCell>
                                                    <StyledTableCell>
                                                        <CustomTextField
                                                            name="obs"
                                                            value={obj_aquisicoes?.obs}
                                                            onChange={onInputChage}
                                                        />
                                                    </StyledTableCell>
                                                </>
                                            ) : (
                                                <>
                                                    <StyledTableCell>{row.data}</StyledTableCell>
                                                    <StyledTableCell>{row.produto} </StyledTableCell>
                                                    <StyledTableCell>{row.quantidade} {row.medida}</StyledTableCell>
                                                    <StyledTableCell>{row.fornecedor} </StyledTableCell>
                                                    <StyledTableCell>{row.origem}</StyledTableCell>
                                                    <StyledTableCell>{row.destino}</StyledTableCell>
                                                    <StyledTableCell>{row.doc}</StyledTableCell>
                                                    <StyledTableCell> {row.consumo_energetico} {row.medida_energetico}</StyledTableCell>
                                                    {/* <StyledTableCell>
                                                            <Link
                                                                href={api + `/static/docs/${row.obs}`}
                                                                color="inherit"
                                                                target="_blank"
                                                            >
                                                                {row.obs}
                                                            </Link>
                                                        </StyledTableCell> */}
                                                    <StyledTableCell> {row.obs} </StyledTableCell>
                                                </>
                                            )}

                                            {obj_aquisicoes?.id_entradas === row.id_entradas ? (
                                                <StyledTableCell>
                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => handleUpdate()}
                                                        mostrarBotaoCancelar
                                                        aoClicarCancelar={() => {
                                                            if (flag_editado) {
                                                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                            } else {
                                                                handleCancel()
                                                            }
                                                        }}
                                                    />
                                                </StyledTableCell>
                                            ) : (
                                                <StyledTableCell>
                                                    {is_historico === true ? <></> :

                                                        <ButtonCadernos
                                                            mostrarBotaoEditar
                                                            aoClicarEditar={() => {
                                                                handleEdit(row)
                                                                setobj_aquisicoesBackup(row)
                                                                set_error_unidade_consumo_energetico(false);
                                                                set_error_unidade_medida_quantidade(false);
                                                                set_error_quantidade(false);
                                                                set_error_consumo_energetico(false);
                                                                set_error_doc(false);
                                                                setShowNewRow(false)
                                                            }}
                                                            mostrarBotaoApagar
                                                            aoClicarApagar={() =>
                                                                handleClickOpenDelete(row)
                                                            }
                                                        />}
                                                </StyledTableCell>
                                            )}
                                        </TableRow>
                                    ))}
                                    {emptyRows > 0 && (
                                        <TableRow style={{ height: 53 * emptyRows }}>
                                            <TableCell colSpan={12} />
                                        </TableRow>
                                    )}
                                </TableBody>
                                {is_tabela_sem_dados && (
                                    <TableRow>
                                        <TableCell colSpan={16}>
                                            <Typography style={{ fontSize: 18, fontFamily: "candara", fontStyle: "italic" }}>
                                                (Tabela ainda sem dados)
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                                <TableRow>

                                    <TableCell colSpan={16}>
                                        <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                                            * Campos de preenchimento obrigatório
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 20, 50, { label: "All", value: -1 },]}
                                            colSpan={12}
                                            count={rows_filtrada.length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            labelDisplayedRows={({ from, to, count }) => {
                                                return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                                            }}
                                            labelRowsPerPage={'Linhas por página'}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>

                                </TableFooter>
                            </table>
                        </TableContainer>
                    </CustomThemeProvider>

                )}

                {
                    open_modal_confirmar_dados_da_fatura === false ? <></> :
                        <ModalValidarDadosFatura
                            lista_artigos={list_aux_from_faturas_obj_aquisicoes === undefined ? [] : list_aux_from_faturas_obj_aquisicoes}
                            flag_open_modal={open_modal_confirmar_dados_da_fatura}
                            set_flag_open_modal={set_open_modal_confirmar_dados_da_fatura}
                            setMessage={setMessage}
                            setOpenSnackError={setOpenSnackError}
                            setOpenSnackSuccess={setOpenSnackSuccess}
                            set_lista_artigos={set_list_aux_from_faturas_obj_aquisicoes}
                            setRows={setRows}
                            setRows_filtrada={setRows_filtrada}

                        ></ModalValidarDadosFatura>

                }
                <ConfirmDialog
                    open={openDelete}
                    onClose={() => setOpenDelete(false)}
                    onConfirm={handleDelete}
                    message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                    open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                    onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                    onConfirm={() => handleCloseDialog()}
                    message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
            </main>
        </div>
    );
}
